export const initializeValidation = (form, inputs) => {
  let isFormSubmitted = false;

  const validateInput = input => {
    const value = input.value.trim();
    const errorMessage = input.nextElementSibling;

    input.classList.remove('formModal__input--error');
    if (errorMessage) errorMessage.textContent = '';

    if (!isFormSubmitted) return true;

    if (!value) {
      input.classList.add('formModal__input--error');
      if (errorMessage) errorMessage.textContent = 'This field is required.';
      return false;
    }

    if (input.type === 'email' && !/\S+@\S+\.\S+/.test(value)) {
      input.classList.add('formModal__input--error');
      if (errorMessage)
        errorMessage.textContent = 'Please enter a valid email address.';
      return false;
    }

    return true;
  };

  const validateForm = () => {
    let isValid = true;
    inputs.forEach(input => {
      const isFieldValid = validateInput(input);
      if (!isFieldValid) isValid = false;
    });
    return isValid;
  };

  form.addEventListener('submit', e => {
    e.preventDefault();
    isFormSubmitted = true;

    const isValid = validateForm();

    if (isValid) {
      console.log('Form is valid! Proceeding...');
      form.dispatchEvent(new CustomEvent('formValid'));
    } else {
      console.log('Form contains errors.');
    }
  });

  inputs.forEach(input => {
    input.addEventListener('input', () => {
      validateInput(input);
    });
  });

  const resetValidation = () => {
    isFormSubmitted = false;
    inputs.forEach(input => {
      input.classList.remove('formModal__input--error');
      const errorMessage = input.nextElementSibling;
      if (errorMessage) errorMessage.textContent = '';
    });
  };

  return { validateForm, resetValidation };
};
